import { Components, Theme } from "@mui/material";

const MuiBackdrop: Components<Theme>["MuiBackdrop"] = {
    defaultProps: {
        sx: {
            backgroundColor: "var(--mui-palette-blackAlpha-500)",
        },
    },
};

export { MuiBackdrop };
